import { render, staticRenderFns } from "./messageExchangeContactInfo.vue?vue&type=template&id=52112dbc&scoped=true"
import script from "./messageExchangeContactInfo.vue?vue&type=script&lang=js"
export * from "./messageExchangeContactInfo.vue?vue&type=script&lang=js"
import style0 from "./messageExchangeContactInfo.vue?vue&type=style&index=0&id=52112dbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52112dbc",
  null
  
)

export default component.exports